import COUNTRIES from '../countries.translations'

import translations from './platinum.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/platinum'

export const platinum: Metal = {
  id: 20,
  slug: 'platinum',
  name: t.name,
  symbol: 'Pt',
  mines: [
    {
      name: 'Bushveld Complex, Rustenburg district (South Africa): Anglo American Platinum, Impala Platinum, Sibanye-Stillwater',
      region: t.mine0Region,
      slug: 'bushveld-complex-rustenburg-district',
      coordinates: [27.24, -25.67],
    },
    {
      name: 'Norilsk (Russia, Nornickel)',
      region: t.mine1Region,
      slug: 'norilsk',
      coordinates: [88.2, 69.33],
    },
    {
      name: 'Great Dyke (Zimbabwe, Zimplats/Mimosa)',
      region: t.mine2Region,
      slug: 'great-dyke',
      coordinates: [31.14, -16.46],
    },
  ],
  countries: [
    { name: COUNTRIES.southAfrica, percent: 70.6 },
    { name: COUNTRIES.zimbabwe, percent: 11.2 },
    { name: COUNTRIES.russia, percent: 10.6 },
    { name: COUNTRIES.canada, percent: 3.1 },
    { name: COUNTRIES.unitedStates, percent: 1.2 },
  ],
  related: ['palladium', 'ruthenium', 'copper', 'nickel'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 5, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 2, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
    },
  },
}
